export interface IRejectionReasonHF {
    id?: string;
    enRejectionReason?: string;
    stRejectionReason?: string;
    countryId?: string;
    rejectionReasonHfCountryId?:string;
    isActive?: boolean;
  }

  export const defaultValue: Readonly<IRejectionReasonHF> = {};
